import { Select } from "antd"
import config, { getCurrentLanguage, setLanguage } from "./config"

const { Option } = Select

const LanguageSwitcher = ({ collapsed }) => {
  const currentLang = getCurrentLanguage().languageId

  const handleChange = (langId) => {
    setLanguage(langId)
    window.location.reload() // reload to apply language change
  }

  return (
    <Select
    size="small"
      value={currentLang}
      onChange={handleChange}
      bordered={!collapsed}
      style={{
        backgroundColor: "transparent",
        boxShadow: "none",
        border: "none",
        width: collapsed ? 40 : 110,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      dropdownStyle={{ minWidth: 120 }}
    >
      {config.options.map(({ languageId, text, icon }) => (
        <Option key={languageId} value={languageId}>
          <span
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <img
              src={icon}
              alt={text}
              style={{ width: 20, marginRight: collapsed ? 0 : 8 }}
            />
            {!collapsed && text}
          </span>
        </Option>
      ))}
    </Select>
  )
}

export default LanguageSwitcher
